import { render, staticRenderFns } from "./FormAddItemTabelaPreco.vue?vue&type=template&id=912053a8&"
import script from "./FormAddItemTabelaPreco.vue?vue&type=script&lang=js&"
export * from "./FormAddItemTabelaPreco.vue?vue&type=script&lang=js&"
import style0 from "./FormAddItemTabelaPreco.vue?vue&type=style&index=0&id=912053a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports